import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import i18n from './strings/i18n';
import { DefaultProviders } from '../default-providers';
import ConfigContextProvider from './context';
import CreditLimitIncreaseContent from './modal/content';
import { getImages } from './modal/utils/StatusMessageHandler';
import { ErrorMessage } from './modal/utils/StatusMessage';
const CreditLimitIncreaseRoot = ({ config, selectedAccountId, handleClose, triggerAnalyticsEvent }) => {
    const languageInStorage = localStorage.getItem('language');
    const currentState = {
        config,
        selectedAccountId,
        handleClose,
        triggerAnalyticsEvent
    };
    useEffect(() => {
        if (languageInStorage) {
            i18n.changeLanguage(languageInStorage).catch(error => error);
        }
        else {
            localStorage.setItem('language', 'en');
        }
    }, [languageInStorage]);
    const { error: errorImage } = getImages({ config });
    return (_jsx(ErrorBoundary, { fallback: _jsx(ErrorMessage, { id: "cli-error-root-boundary", image: errorImage }), children: _jsx(DefaultProviders, { config: config, children: _jsx(ConfigContextProvider, { state: currentState, children: _jsx(CreditLimitIncreaseContent, {}) }) }) }));
};
export default CreditLimitIncreaseRoot;
